import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  catchErrorAndEvict,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { SITE_MASTER_LIST } from '../../../graphql';
import { SiteMasterListModel } from '../../../models';

@Injectable({ providedIn: 'root' })
export class SiteMasterListService {
  private readonly apollo = inject(Apollo);

  private clientName = APOLLO_CLIENT_NAMES.contact;

  getSiteMasterList(): Observable<SiteMasterListModel> {
    const fieldName =
      getQueryRootFieldName(SITE_MASTER_LIST) || 'masterSiteList';

    return this.apollo
      .use(this.clientName)
      .query({
        query: SITE_MASTER_LIST,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data?.masterSiteList),
        catchErrorAndEvict(this.apollo, this.clientName, fieldName),
      );
  }
}
